/**
 * Annual-pass voucher expiry check.
 *
 * Lives here rather than in PassSettingsPage.duck because `fetchCurrentUser` dispatches it on every
 * page load: importing it from the page duck pulled that whole (code-split) duck back into the main
 * bundle, and importing it dynamically would fetch the page chunk on every page load instead.
 *
 * The action types keep their `app/PassSettingsPage/` namespace — PassSettingsPage.duck imports
 * them for its reducer, so the in-progress/error state is still filled whenever that page is
 * loaded. Import direction is one-way: PassSettingsPage.duck -> here, never the reverse.
 */

import { updateUserProfile } from './user.duck';
import dayjs from '../util/dayjs';
import { logError } from '../util/log';

// ================ Action types ================ //

export const CHECK_PASS_VOUCHER_REQUEST = 'app/PassSettingsPage/CHECK_PASS_VOUCHER_REQUEST';
export const CHECK_PASS_VOUCHER_SUCCESS = 'app/PassSettingsPage/CHECK_PASS_VOUCHER_SUCCESS';
export const CHECK_PASS_VOUCHER_ERROR = 'app/PassSettingsPage/CHECK_PASS_VOUCHER_ERROR';

// ================ Action creators ================ //

export const checkPassVoucherRequest = () => ({ type: CHECK_PASS_VOUCHER_REQUEST });
export const checkPassVoucherSuccess = () => ({ type: CHECK_PASS_VOUCHER_SUCCESS });
export const checkPassVoucherError = (error) => ({
  type: CHECK_PASS_VOUCHER_ERROR,
  payload: error,
});

// ================ Thunks ================ //

export const checkPassVoucher = () => async (dispatch, getState, sdk) => {
  const { currentUser } = getState().user;
  let annualPass = currentUser?.attributes?.profile?.privateData?.annualPass;
  if (!annualPass) return;
  dispatch(checkPassVoucherRequest());
  try {
    const isExpired = dayjs.utc(annualPass.validUntil).isBefore(dayjs.utc());
    if (isExpired) {
      dispatch(
        updateUserProfile({
          privateData: { annualPass: null, hasAnnualPass: null },
          protectedData: { annualPassLicensePlate: null },
        }),
      );
    }
    dispatch(checkPassVoucherSuccess());
  } catch (e) {
    logError(e, 'check-annual-pass-voucher', { currentUser, annualPass });
    dispatch(checkPassVoucherError(e));
  }
};
